import React from "react";

export const NoRecordFound = ({ message = "No Records Found", icon = "ti ti-file-invoice" }) => {
  return (
    <div className="payaccount-empty text-center w-100 py-5 px-3">
      <span className="wes-catalogue jump-spin" style={{ fontSize: 30 }}></span>
      <div className="payaccount-empty-text">{message}</div>
    </div>
  );
};

export default NoRecordFound;
